// src/enums/const.ts
var Constants = /* @__PURE__ */ ((Constants2) => {
  Constants2["ACCESS_TOKEN"] = "access_token";
  Constants2["USERNAME"] = "username";
  Constants2["SESSION"] = "session";
  return Constants2;
})(Constants || {});

// src/enums/env.ts
var ServerEnv = /* @__PURE__ */ ((ServerEnv2) => {
  ServerEnv2["PORT"] = "PORT";
  ServerEnv2["JWT_SECRET"] = "JWT_SECRET";
  ServerEnv2["AWS_ACCESS_KEY_ID"] = "AWS_ACCESS_KEY_ID";
  ServerEnv2["AWS_SECRET_ACCESS_KEY"] = "AWS_SECRET_ACCESS_KEY";
  ServerEnv2["AWS_REGION"] = "AWS_REGION";
  ServerEnv2["AWS_S3_BUCKET"] = "AWS_S3_BUCKET";
  ServerEnv2["DATABASE_URL"] = "DATABASE_URL";
  ServerEnv2["MASTRA_ENDPOINT"] = "MASTRA_ENDPOINT";
  return ServerEnv2;
})(ServerEnv || {});
var MastraEnv = /* @__PURE__ */ ((MastraEnv2) => {
  MastraEnv2["OPENAI_API_KEY"] = "OPENAI_API_KEY";
  MastraEnv2["DATABASE_URL"] = "DATABASE_URL";
  return MastraEnv2;
})(MastraEnv || {});

// src/enums/mime-type.ts
var MimeType = /* @__PURE__ */ ((MimeType2) => {
  MimeType2["AAC"] = "audio/aac";
  MimeType2["ABW"] = "application/x-abiword";
  MimeType2["APNG"] = "image/apng";
  MimeType2["ARC"] = "application/x-freearc";
  MimeType2["AVIF"] = "image/avif";
  MimeType2["AVI"] = "video/x-msvideo";
  MimeType2["AZW"] = "application/vnd.amazon.ebook";
  MimeType2["BIN"] = "application/octet-stream";
  MimeType2["BMP"] = "image/bmp";
  MimeType2["BZ"] = "application/x-bzip";
  MimeType2["BZ2"] = "application/x-bzip2";
  MimeType2["CDA"] = "application/x-cdf";
  MimeType2["CSH"] = "application/x-csh";
  MimeType2["CSS"] = "text/css";
  MimeType2["CSV"] = "text/csv";
  MimeType2["DOC"] = "application/msword";
  MimeType2["DOCX"] = "application/vnd.openxmlformats-officedocument.wordprocessingml.document";
  MimeType2["EOT"] = "application/vnd.ms-fontobject";
  MimeType2["EPUB"] = "application/epub+zip";
  MimeType2["GZ"] = "application/gzip";
  MimeType2["GIF"] = "image/gif";
  MimeType2["HTML"] = "text/html";
  MimeType2["ICO"] = "image/vnd.microsoft.icon";
  MimeType2["ICS"] = "text/calendar";
  MimeType2["JAR"] = "application/java-archive";
  MimeType2["JPEG"] = "image/jpeg";
  MimeType2["JS"] = "text/javascript";
  MimeType2["JSON"] = "application/json";
  MimeType2["JSONLD"] = "application/ld+json";
  MimeType2["MIDI"] = "audio/midi";
  MimeType2["MP3"] = "audio/mpeg";
  MimeType2["MP4"] = "video/mp4";
  MimeType2["MPEG"] = "video/mpeg";
  MimeType2["MPKG"] = "application/vnd.apple.installer+xml";
  MimeType2["ODP"] = "application/vnd.oasis.opendocument.presentation";
  MimeType2["ODS"] = "application/vnd.oasis.opendocument.spreadsheet";
  MimeType2["ODT"] = "application/vnd.oasis.opendocument.text";
  MimeType2["OGA"] = "audio/ogg";
  MimeType2["OGV"] = "video/ogg";
  MimeType2["OGX"] = "application/ogg";
  MimeType2["OTF"] = "font/otf";
  MimeType2["PNG"] = "image/png";
  MimeType2["PDF"] = "application/pdf";
  MimeType2["PHP"] = "application/x-httpd-php";
  MimeType2["PPT"] = "application/vnd.ms-powerpoint";
  MimeType2["PPTX"] = "application/vnd.openxmlformats-officedocument.presentationml.presentation";
  MimeType2["RAR"] = "application/vnd.rar";
  MimeType2["RTF"] = "application/rtf";
  MimeType2["SH"] = "application/x-sh";
  MimeType2["SVG"] = "image/svg+xml";
  MimeType2["TAR"] = "application/x-tar";
  MimeType2["TIFF"] = "image/tiff";
  MimeType2["TS"] = "video/mp2t";
  MimeType2["TTF"] = "font/ttf";
  MimeType2["TXT"] = "text/plain";
  MimeType2["VSD"] = "application/vnd.visio";
  MimeType2["WAV"] = "audio/wav";
  MimeType2["WEBA"] = "audio/webm";
  MimeType2["WEBM"] = "video/webm";
  MimeType2["WEBP"] = "image/webp";
  MimeType2["WOFF"] = "font/woff";
  MimeType2["WOFF2"] = "font/woff2";
  MimeType2["XHTML"] = "application/xhtml+xml";
  MimeType2["XLS"] = "application/vnd.ms-excel";
  MimeType2["XLSX"] = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
  MimeType2["XML"] = "application/xml";
  MimeType2["XUL"] = "application/vnd.mozilla.xul+xml";
  MimeType2["ZIP"] = "application/zip";
  MimeType2["Z7Z"] = "application/x-7z-compressed";
  MimeType2["GP3"] = "video/3gpp";
  MimeType2["GP2"] = "video/3gpp2";
  MimeType2["MARKDOWN"] = "text/markdown";
  return MimeType2;
})(MimeType || {});

// src/enums/topic.ts
var Topic = /* @__PURE__ */ ((Topic2) => {
  Topic2["MESSAGE"] = "message";
  Topic2["MESSAGE_HISTORY"] = "message:history";
  Topic2["SESSION"] = "session";
  return Topic2;
})(Topic || {});

// src/formatter/bytes.ts
var formatBytes = (bytes, decimals = 2) => {
  if (bytes === 0) {
    return "0 Bytes";
  }
  const kilo = 1024;
  const dm = Math.max(0, decimals);
  const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB"];
  const i = Math.floor(Math.log(bytes) / Math.log(kilo));
  const value = bytes / kilo ** i;
  return `${parseFloat(value.toFixed(dm))} ${sizes[i]}`;
};

// src/formatter/date.ts
import { DateTime } from "luxon";
var dateTime = (date2) => DateTime.fromJSDate(date2).toFormat("dd/MM/yyyy HH:mm");
var date = (date2) => DateTime.fromJSDate(date2).toFormat("dd/MM/yyyy");
var time = (date2) => DateTime.fromJSDate(date2).toFormat("HH:mm");

// src/formatter/percentage.ts
var percentage = (value, fixed = 0) => `${(value * 100).toFixed(fixed)}%`;

// src/formatter/index.ts
var formatter = {
  date: {
    dateTime,
    date,
    time
  },
  bytes: {
    format: formatBytes
  },
  percentage
};

// src/mastra/config.ts
var CHAT_AGENT_ID = "chat-agent";
var DATA_AGENT_ID = "data-agent";
var ZOD_AGENT_ID = "zod-agent";
var CATEGORIES_TOOL_ID = "categories-tool";
var UPLOAD_DATASET_WORKFLOW_ID = "upload-dataset-workflow";

// src/mastra/schemas.ts
import { z } from "zod";
var snapshotSchema = z.object({
  status: z.enum(["active", "completed", "failed"]),
  context: z.object({
    steps: z.record(
      z.string(),
      z.object({
        status: z.enum(["success", "failed"]),
        output: z.any()
      })
    ),
    attempts: z.record(z.string(), z.number())
  })
});
var classifyStepOutputSchema = z.record(z.string(), z.array(z.string()));
var classifySnapshotSchema = snapshotSchema.extend({
  context: snapshotSchema.shape.context.extend({
    steps: z.union([
      snapshotSchema.shape.context.shape.steps,
      z.object({
        classify: z.object({
          status: z.string(),
          output: classifyStepOutputSchema
        })
      })
    ])
  })
});

// src/types/tracing.ts
import { z as z2 } from "zod";
var eventAttributesSchema = z2.object({
  key: z2.string(),
  value: z2.any()
});
var eventSchema = z2.object({
  attributes: z2.array(eventAttributesSchema),
  name: z2.string(),
  timeUnixNano: z2.string(),
  droppedAttributesCount: z2.number()
});
var linkSchema = z2.any();
var otherSchema = z2.object({
  droppedAttributesCount: z2.number(),
  droppedEventsCount: z2.number(),
  droppedLinksCount: z2.number()
});
var spanStatusSchema = z2.object({
  code: z2.number()
});
var baseSpanSchema = z2.object({
  id: z2.string(),
  parentSpanId: z2.string().optional().nullable(),
  traceId: z2.string(),
  name: z2.string(),
  scope: z2.string(),
  /**
   * 0: Within process
   * 1: Outgoing calls
   * 2: Incoming calls
   * 3: Async job creation
   * 4: Async job processing
   */
  kind: z2.number(),
  status: spanStatusSchema,
  events: z2.array(eventSchema),
  links: z2.array(linkSchema),
  attributes: z2.record(z2.string(), z2.any()),
  startTime: z2.string().transform((val) => Number(val)),
  endTime: z2.string().transform((val) => Number(val)),
  other: z2.string().transform((val) => otherSchema.parse(JSON.parse(val))),
  createdAt: z2.string().transform((val) => new Date(val))
});
var spanSchema = baseSpanSchema.transform((data) => ({
  ...data,
  duration: data.endTime - data.startTime
}));
var spanNodeSchema = baseSpanSchema.extend({
  children: z2.lazy(() => z2.array(spanNodeSchema)),
  relativePercentage: z2.number().optional(),
  duration: z2.number()
}).transform((data) => ({
  ...data,
  duration: data.endTime - data.startTime
}));
var refinedTraceSchema = z2.object({
  traceId: z2.string(),
  serviceName: z2.string(),
  duration: z2.number(),
  started: z2.number(),
  status: spanStatusSchema,
  trace: z2.array(spanSchema)
});

// src/utils/assert.ts
var assert = (value, message = "Value is not defined") => {
  if (value === null || value === void 0) {
    throw new Error(message);
  }
};

// src/utils/jwt.ts
var parseJWT = (token) => {
  const payloadBase64 = token.split(".")[1];
  if (!payloadBase64) {
    throw new Error("Invalid token");
  }
  const payloadJson = atob(payloadBase64);
  return JSON.parse(payloadJson);
};

// src/utils/mime-type.ts
var getMimeType = (file) => {
  if (file.mimetype !== "application/octet-stream" /* BIN */) {
    return file.mimetype;
  }
  const detectors = [
    {
      predicate: (_file) => _file.mimetype === "text/markdown" /* MARKDOWN */ || _file.originalname.toLowerCase().endsWith(".md"),
      mimeType: "text/markdown" /* MARKDOWN */
    }
  ];
  for (const detector of detectors) {
    if (detector.predicate(file)) {
      return detector.mimeType;
    }
  }
  return file.mimetype;
};
export {
  CATEGORIES_TOOL_ID,
  CHAT_AGENT_ID,
  Constants,
  DATA_AGENT_ID,
  MastraEnv,
  MimeType,
  ServerEnv,
  Topic,
  UPLOAD_DATASET_WORKFLOW_ID,
  ZOD_AGENT_ID,
  assert,
  classifySnapshotSchema,
  eventAttributesSchema,
  eventSchema,
  formatter,
  getMimeType,
  linkSchema,
  otherSchema,
  parseJWT,
  refinedTraceSchema,
  spanNodeSchema,
  spanSchema,
  spanStatusSchema
};
